var map = {
	"./E-WEB-Goal-1.png": 5430,
	"./E-WEB-Goal-10.png": 8724,
	"./E-WEB-Goal-11.png": 1965,
	"./E-WEB-Goal-12.png": 198,
	"./E-WEB-Goal-13.png": 3999,
	"./E-WEB-Goal-14.png": 5968,
	"./E-WEB-Goal-15.png": 169,
	"./E-WEB-Goal-16.png": 1986,
	"./E-WEB-Goal-17.png": 3531,
	"./E-WEB-Goal-2.png": 2461,
	"./E-WEB-Goal-3.png": 9956,
	"./E-WEB-Goal-4.png": 9899,
	"./E-WEB-Goal-5.png": 898,
	"./E-WEB-Goal-6.png": 9689,
	"./E-WEB-Goal-7.png": 4864,
	"./E-WEB-Goal-8.png": 8487,
	"./E-WEB-Goal-9.png": 798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9006;